import { Injectable } from "@angular/core";
import { BaseManager } from "./base.manager";
import { LocalStorageRepositoryInterface } from "../../datastore/local/localstorage.interface";
import { Observable } from "rxjs";
import { EmployeeRepositoryInterface } from "app/datastore/repositories/employee/employee.interface";
import { EmployeeModel } from "../../datastore/entities/employee.model";

@Injectable()
export class EmployeeManager extends BaseManager {
    constructor(
        protected localStorageRepository: LocalStorageRepositoryInterface,
        private employeeRepository: EmployeeRepositoryInterface) {
        super(localStorageRepository);
    }

    public createEmployee(employee: EmployeeModel): Observable<EmployeeModel> {
        return this.employeeRepository.createEmployee(employee);
    }

    public editEmployee(id: number, employee: EmployeeModel): Observable<EmployeeModel> {
        return this.employeeRepository.editEmployee(id, employee);
    }

    public deleteEmployee(id: number): void {
        return this.employeeRepository.deleteEmployee(id);
    }

}
